import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import '../resetPassword/resetPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setMessage("");

    const isEmailValid = /^[\w.-]+@[\w.-]+\.[a-zA-Z]{2,4}$/.test(email);
    if (!email || !isEmailValid) {
      setError("Please enter a valid email address");
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await axios.post("/api/v1/forgot-password", { email });
      setMessage(response.data.message);
    } catch (err) {
      if (err.response) {
        setError(err.response.data.message);
      } else {
        setError("An error occurred. Please try again.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="sr-reset">
      <div className="sr-reset__top">
        <h1 className="sr-reset__title">Forgot Password</h1>
        <p className="sr-reset__subtitle">Enter your email address and we'll send you a link to reset your password.</p>
      </div>

      <div className="sr-reset__body">
        <form onSubmit={handleSubmit} className="sr-reset__form">
          <input
            type="email"
            value={email}
            onChange={(e) => { setEmail(e.target.value); setError(""); setMessage(""); }}
            placeholder="Email address"
          />
          {error && <label className="sr-reset__error">{error}</label>}
          {message && <label className="sr-reset__success">{message}</label>}
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Sending..." : "Send Reset Link"}
          </button>
          <p className="sr-reset__link"><Link to="/login">Back to Login</Link></p>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
